export default function Machines_C_2 (number = 1) {
  return {
    name: '极速分拣器',
    icon: '/static/img/machines/c2.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_C/Machines_C_2.js